import { PriceDropTimePeriod, TimeUnit } from "apollo/graphql.generated";

export const getPriceDropIntervalTime = (
  priceDropInterval?: PriceDropTimePeriod[] | null
) => {
  return (
    priceDropInterval?.reduce((timeInterval, timePeriod) => {
      switch (timePeriod.unit) {
        case TimeUnit.HOURS:
          timeInterval += timePeriod.value * 60 * 60 * 1000;
          break;
        case TimeUnit.MINUTES:
          timeInterval += timePeriod.value * 60 * 1000;
          break;
      }
      return timeInterval;
    }, 0) || 0
  );
};
